export default __webpack_public_path__ + "static/23_34-abb0966a44df69ddda115132925b901a.png";